import { render, staticRenderFns } from "./agoraDes.vue?vue&type=template&id=75fecbba&scoped=true"
import script from "./agoraDes.vue?vue&type=script&lang=js"
export * from "./agoraDes.vue?vue&type=script&lang=js"
import style0 from "./agoraDes.vue?vue&type=style&index=0&id=75fecbba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fecbba",
  null
  
)

export default component.exports